export const searchSelector = (state) => state.search;
export const levelSelector = (state) => state.search.level;
export const searchFilterSelector = (state) => state.search.filters;